module.exports = __webpack_public_path__ + "img/文化慕课.3d448dcc.png";